module.exports = __webpack_public_path__ + "static/media/Postcard.d54889e2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/LandingPage/images/Postcard.svg
// module id = 948
// module chunks = 0